import { moleculeHeadingFields } from 'molecules/Heading/config';
import { iconIds } from 'molecules/Icon/types';
import sectionFields from 'molecules/Section/config';

import type { Component, Input } from '@builder.io/sdk';

const iconEnum = iconIds.map(id => ({ label: id, value: id }));

const eventExperienceFields = [
  {
    name: 'heading',
    type: 'object',
    subFields: moleculeHeadingFields,
    helperText: 'Heading block for this section. Use the eyebrow for the label (e.g. "WHAT TO EXPECT").',
  },
  {
    name: 'items',
    type: 'list',
    helperText: 'Add the experience pills. Each pill shows an icon and a non-clickable label.',
    subFields: [
      { name: 'id', type: 'string', required: true, showIf: 'false' },
      {
        name: 'icon',
        type: 'string',
        enum: iconEnum,
        defaultValue: 'play-circle',
        helperText: 'Icon shown on the left of the pill.',
      },
      {
        name: 'label',
        type: 'string',
        required: true,
        defaultValue: 'Live sessions',
        helperText: 'Pill label (required).',
      },
    ],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      options.get('items').forEach((item: Map<string, string>, index: number) => {
        item.set('id', `item-${index}`);
      });
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const eventExperienceConfig = {
  name: 'EventExperience',
  inputs: eventExperienceFields,
} satisfies Component;

export type EventExperienceConfigProps = GenerateBuilder<typeof eventExperienceFields>;

export default eventExperienceConfig;
